import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./theme/fonts.css";

import "./i18n";
import "./theme/adaltra.css";
import "./theme/adaltraView.css";
import App from "./App";
import { ApplicationTheme } from "./components/ApplicationTheme";
import { SessionProvider } from "./context/SessionContext";
import { registerPwa } from "./pwa";

registerPwa();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <BrowserRouter>
      <ApplicationTheme>
        <SessionProvider>
          <App />
        </SessionProvider>
      </ApplicationTheme>
    </BrowserRouter>
  </StrictMode>,
);
